export const COLORS = {
  brunswick: [{
      name: "Spruce",
      src: "Magnet/Kitchens/Swatches/Spruce-swatch.jpg",
    },
    {
      name: "Sumi Black",
      src: "Magnet/Kitchens/Swatches/Sumi-black-swatch.jpg",
    },
    {
      name: "Limestone",
      src: "Magnet/Kitchens/Swatches/Limestone_swatch.png",
    },
    {
      name: "Voyage Blue",
      src: "Magnet/Kitchens/Swatches/Voyage_blue_swatch.jpg",
    }
  ],
  wardley:[
    {
      name: 'Wardley morello',
      src: 'Magnet/Kitchens/Swatches/Morello_swatch.png',
    },
    {
      name: 'Wardley parchment',
      src: 'Magnet/Kitchens/Swatches/Parchment-swatch.jpg',
    },
    {
      name: 'Wardley tailored green',
      src: 'Magnet/Kitchens/Swatches/Tailored-Green_swatch.png',
    },
    {
      name: 'Wardley sumi black',
      src: 'Magnet/Kitchens/Swatches/Sumi-black-swatch.jpg',
    },
    {
      name: 'Wardley shell',
      src: 'Magnet/Kitchens/Swatches/Swatch_Shell.png',
    },
    {
      name: 'Wardley thyme',
      src: 'Magnet/Kitchens/Swatches/Swatch_Thyme.png',
    },
    {
      name: 'Wardley duck egg',
      src: 'Magnet/Kitchens/Swatches/Swatch_Duck-Egg.png',
    },
    {
      name: 'Wardley baked clay',
      src: 'Magnet/Kitchens/Swatches/Swatch_Baked-Clay.png',
    },
    {
      name: 'Wardley balmoral',
      src: 'Magnet/Kitchens/Swatches/Balmoral_swatch.png',
    },
    {
      name: 'Wardley coastland',
      src: 'Magnet/Kitchens/Swatches/Coastland_swatch.png',
    },
    {
      name: 'Wardley french clay',
      src: 'Magnet/Kitchens/Swatches/French_Clay_swatch.png',
    },
    {
      name: 'Wardley limestone',
      src: 'Magnet/Kitchens/Swatches/Limestone_swatch.png',
    },
    {
      name: 'Wardley chalk blush',
      src: 'Magnet/Kitchens/Swatches/Chalk_Blush_swatch.jpg',
    },
    {
      name: 'Wardley carrington blue',
      src: 'Magnet/Kitchens/Swatches/Carrington_blue_swatch.jpg',
    },
    {
      name: 'Wardley harvest',
      src: 'Magnet/Kitchens/Swatches/harvest_swatch.jpg',
    },
    {
      name: 'Wardley fresh linen',
      src: 'Magnet/Kitchens/Swatches/Fresh_Linen_swatch.png',
    },
    {
      name: 'Wardley midnight',
      src: 'Magnet/Kitchens/Swatches/Midnight_swatch.png',
    },
    {
      name: 'Wardley pebble path',
      src: 'Magnet/Kitchens/Swatches/Pebble_Path_swatch.png',
    },
    {
      name: 'Wardley seagrass',
      src: 'Magnet/Kitchens/Swatches/Seagrass_swatch.png',
    },
    {
      name: 'Wardley arboretum green',
      src: 'Magnet/Kitchens/Swatches/Arborteum_green_swatch.jpg',
    },
    {
      name: 'Wardley morris blue',
      src: 'Magnet/Kitchens/Swatches/Morris_Blue_swatch.png',
    },
    {
      name: 'Wardley charcoals',
      src: 'Magnet/Kitchens/Swatches/Charcoals_swatch.png',
    },
    {
      name: 'Wardley dove grey',
      src: 'Magnet/Kitchens/Swatches/Dove_Grey_swatch.png',
    },
    {
      name: 'Wardley ecalyptus green',
      src: 'Magnet/Kitchens/Swatches/Eucalyptus_swatch.png',
    },
    {
      name: 'Wardley misty moors',
      src: 'Magnet/Kitchens/Swatches/Misty_Moors_swatch.jpg',
    },
    {
      name: 'Wardley sky',
      src: 'Magnet/Kitchens/Swatches/Sky_swatch.png',
    },
    {
      name: 'Wardley washed cotton',
      src: 'Magnet/Kitchens/Swatches/Washed_Cotton_swatch.png',
    },
    {
      name: 'Wardley voyage blue',
      src: 'Magnet/Kitchens/Swatches/Voyage_blue_swatch.jpg',
    },
  ],
  duxbury:[
    {
      name: 'Fawn',
      src: 'Magnet/Price%20Configurator/Colors/duxbury_fawn_swatch.png',
    },
    {
      name: 'Arboretum',
      src: 'Magnet/Price%20Configurator/Colors/duxbury_arboretum_swatch.png',
    },
    {
      name: 'Limestone',
      src: 'Magnet/Price%20Configurator/Colors/duxbury_limestone_swatch.png',
    },
  ],
  bewdley: [
    {
      name: 'Bewdley Dove Grey',
      src: '/Magnet/Kitchens/Soho/Soho_Dove_Grey_Front.jpg',
    },
    {
      name: 'Bewdley Sky',
      src: 'Magnet/Kitchens/Magnet/Kitchens/Soho/Soho_Sky_Front.jpg',
    },
    {
      name: 'Bewdley Midnight',
      src: 'Magnet/Kitchens/Dunham/Dunham_Midnight_Front.jpg',
    },
    {
      name: 'Bewdley Seagrass',
      src: 'Development/Soho_Seagrass.jpg',
    },
    {
      name: 'Bewdley Charcoals',
      src: 'Development/Soho_Charcoals.jpg',
    },
    {
      name: 'Bewdley Pebble Path',
      src: 'Magnet/Kitchens/Soho/Soho_Pebble_Path_Front.jpg',
    },
    {
      name: 'Bewdley Washed Cotton',
      src: 'Magnet/Kitchens/Soho/Soho_Washed_Cotton_Front.jpg',
    },
    {
      name: 'Bewdley Fresh Linen',
      src: 'Magnet/Price Configurator/Colors/dunham-fresh-linen.jpg',
    },
    {
      name: 'Bewdley Misty Moors',
      src: 'Magnet/Kitchens/Soho/Misty_Moors.jpg',
    },
    {
      name: 'Bewdley Voyage Blue',
      src: 'Magnet/Kitchens/Dunham/Voyage_blue.jpg',
    },
    {
      name: 'Bewdley Arboretum Green',
      src: 'Magnet/Kitchens/Arborteum_green.jpg',
    },
    {
      name: 'Bewdley Eucalyptus Green',
      src: 'Magnet/Kitchens/Frontals/Eucalyptus.jpg',
    },
    {
      name: 'Bewdley Cornish Clay',
      src: 'Magnet/Kitchens/Swatches/Cornish-Clay-swatch.jpg',
    },
    {
      name: 'Bewdley Portland Blue',
      src: 'MMagnet/Kitchens/Swatches/Portland-blue-swatch.jpg',
    },
    {
      name: 'Bewdley Limestone',
      src: 'Magnet/Kitchens/Frontals/Limestone.jpg',
    },
    {
      name: 'Bewdley Harvest',
      src: 'Magnet/Kitchens/Frontals/Harvest.jpg',
    },
    {
      name: 'Bewdley Chalk Blush',
      src: 'Magnet/Kitchens/Frontals/Chalk_Blush.jpg',
    },
    {
      name: 'Bewdley French Clay',
      src: 'Magnet/French_Clay.jpg',
    },
    {
      name: 'Bewdley Balmoral',
      src: 'Magnet/Balmoral.jpg',
    },
    {
      name: 'Bewdley Shell',
      src: 'Magnet/Kitchens/Swatch_Shell.jpg',
    },
    {
      name: 'Bewdley Duck Egg',
      src: 'Magnet/Kitchens/Swatch_Duck-Egg.jpg',
    },
    {
      name: 'Bewdley Thyme',
      src: 'Magnet/Kitchens/Swatch_Thyme.jpg',
    },
    {
      name: 'Bewdley Baked Clay',
      src: 'Magnet/Kitchens/Swatch_Baked-Clay.jpg',
    },
    {
      name: 'Bewdley Tailored Green',
      src: 'Magnet/Kitchens/Tailored-Green_swatch.jpg',
    },
    {
      name: 'Bewdley Parchment',
      src: 'Magnet/Kitchens/Parchment-swatch.jpg',
    },
    {
      name: 'Bewdley Morello',
      src: 'Magnet/Kitchens/Morello_swatch.jpg',
    },
  ],
  reed: [
    {
      name: 'Reed morello',
      src: 'Magnet/Kitchens/Swatches/Morello_swatch.png',
    },
    {
      name: 'Reed parchment',
      src: 'Magnet/Kitchens/Swatches/Parchment-swatch.jpg',
    },
    {
      name: 'Reed tailored green',
      src: 'Magnet/Kitchens/Swatches/Tailored-Green_swatch.png',
    },
    {
      name: 'Reed sumi black',
      src: 'Magnet/Kitchens/Swatches/Sumi-black-swatch.jpg',
    },
    {
      name: 'Reed shell',
      src: 'Magnet/Kitchens/Swatches/Swatch_Shell.png',
    },
    {
      name: 'Reed thyme',
      src: 'Magnet/Kitchens/Swatches/Swatch_Thyme.png',
    },
    {
      name: 'Reed duck egg',
      src: 'Magnet/Kitchens/Swatches/Swatch_Duck-Egg.png',
    },
    {
      name: 'Reed baked clay',
      src: 'Magnet/Kitchens/Swatches/Swatch_Baked-Clay.png',
    },
    {
      name: 'Reed balmoral',
      src: 'Magnet/Kitchens/Swatches/Balmoral_swatch.png',
    },
    {
      name: 'Reed coastland',
      src: 'Magnet/Kitchens/Swatches/Coastland_swatch.png',
    },
    {
      name: 'Reed french clay',
      src: 'Magnet/Kitchens/Swatches/French_Clay_swatch.png',
    },
    {
      name: 'Reed limestone',
      src: 'Magnet/Kitchens/Swatches/Limestone_swatch.png',
    },
    {
      name: 'Reed chalk blush',
      src: 'Magnet/Kitchens/Swatches/Chalk_Blush_swatch.jpg',
    },
    {
      name: 'Reed carrington blue',
      src: 'Magnet/Kitchens/Swatches/Carrington_blue_swatch.jpg',
    },
    {
      name: 'Reed harvest',
      src: 'Magnet/Kitchens/Swatches/harvest_swatch.jpg',
    },
    {
      name: 'Reed fresh linen',
      src: 'Magnet/Kitchens/Swatches/Fresh_Linen_swatch.png',
    },
    {
      name: 'Reed midnight',
      src: 'Magnet/Kitchens/Swatches/Midnight_swatch.png',
    },
    {
      name: 'Reed pebble path',
      src: 'Magnet/Kitchens/Swatches/Pebble_Path_swatch.png',
    },
    {
      name: 'Reed seagrass',
      src: 'Magnet/Kitchens/Swatches/Seagrass_swatch.png',
    },
    {
      name: 'Reed arboretum green',
      src: 'Magnet/Kitchens/Swatches/Arborteum_green_swatch.jpg',
    },
    {
      name: 'Reed morris blue',
      src: 'Magnet/Kitchens/Swatches/Morris_Blue_swatch.png',
    },
    {
      name: 'Reed charcoals',
      src: 'Magnet/Kitchens/Swatches/Charcoals_swatch.png',
    },
    {
      name: 'Reed dove grey',
      src: 'Magnet/Kitchens/Swatches/Dove_Grey_swatch.png',
    },
    {
      name: 'Reed ecalyptus green',
      src: 'Magnet/Kitchens/Swatches/Eucalyptus_swatch.png',
    },
    {
      name: 'Reed misty moors',
      src: 'Magnet/Kitchens/Swatches/Misty_Moors_swatch.jpg',
    },
    {
      name: 'Reed sky',
      src: 'Magnet/Kitchens/Swatches/Sky_swatch.png',
    },
    {
      name: 'Reed washed cotton',
      src: 'Magnet/Kitchens/Swatches/Washed_Cotton_swatch.png',
    },
    {
      name: 'Reed voyage blue',
      src: 'Magnet/Kitchens/Swatches/Voyage_blue_swatch.jpg',
    },
  ],
  portobello:[
    {
      name: 'Etna',
      src: 'Magnet/Price%20Configurator/Colors/portobello_etna_swatch.png',
    },
    {
      name: 'Umbra',
      src: 'Magnet/Price%20Configurator/Colors/portobello_umbra_swatch.png',
    },
    {
      name: 'Bosco',
      src: 'Magnet/Price%20Configurator/Colors/portobello_bosco_swatch.png',
    },
  ],
  ambleside:[
    {
      name: 'Fern',
      src: 'Magnet/Price%20Configurator/Colors/ambleside_fern_swatch.png',
    },
    {
      name: 'Smoke',
      src: 'Magnet/Price%20Configurator/Colors/ambleside_smoke_swatch.png',
    },
    {
      name: 'Graphite',
      src: 'Magnet/Price%20Configurator/Colors/ambleside_graphite_swatch.png',
    },
    {
      name: 'Moss',
      src: 'Magnet/Price%20Configurator/Colors/ambleside_moss_swatch.png',
    },
    {
      name: 'Limestone',
      src: 'Magnet/Price%20Configurator/Colors/ambleside_limestone_swatch.png',
    },
  ],
  ascoli: [
    {
      name: 'Ascoli mineral blue',
      src: 'Magnet/Kitchens/Swatches/Mineral_blue_swatch.jpg',
    },
    {
      name: 'Ascoli woodland green',
      src: 'Magnet/Kitchens/Swatches/Woodland_swatch.jpg',
    },
    {
      name: 'Ascoli gloss white',
      src: 'Magnet/Kitchens/Swatches/Ascoli_White_Gloss_angled.jpg',
    },
    {
      name: 'Ascoli anthracite',
      src: 'Magnet/Kitchens/Ascoli/Ascoli_Anthracite.png',
    },
    {
      name: 'Ascoli natural oak',
      src: 'Magnet/Kitchens/Frontals/Ascoli_Natural_Oak_new.png',
    },
    {
      name: 'Ascoli pebble',
      src: 'Magnet/Kitchens/Frontals/U201_9_3685x7937.jpg',
    },
    {
      name: 'Ascoli dark oak',
      src: 'Magnet/Kitchens/Swatches/Dark_oak_swatch.png',
    },
    {
      name: 'Ascoli light grey',
      src: 'Magnet/Kitchens/Integra%20Ascoli/Integra_Ascoli_Light_Grey_Swatch.png',
    },
  ],
  nova: [
    {
      name: 'Nova gloss white',
      src: 'Magnet/Kitchens/Nova/Nova_MattWhite_Front.png',
    },
    {
      name: 'Nova matt grey',
      src: 'Magnet/Kitchens/Nova/Nova_MattGrey_Front.png',
    },
    {
      name: 'Nova matt slate',
      src: 'Magnet/Kitchens/Nova/Nova_Matt_Slate_Front.png',
    },
    {
      name: 'Nova matt seagrass',
      src: 'Magnet/Kitchens/Nova/Nova_Seagrass.jpg',
    },
  ],
  tatton: [
    {
      name: 'Tatton pebble',
      src: 'magnet/Price%20Configurator/colors/tatton-pebble.webp',
    },
    {
      name: 'Tatton sage',
      src: 'Magnet/Kitchens/Tatton/tatton_sage_swatch.png',
    },
    {
      name: 'Tatton grey',
      src: 'magnet/Price%20Configurator/colors/tatton-grey.webp',
    },
    {
      name: 'Tatton white',
      src: 'magnet/Price%20Configurator/colors/tatton-white.webp',
    },
    {
      name: 'Tatton graphite',
      src: 'magnet/Price%20Configurator/colors/tatton-graphite.webp',
    },
    {
      name: 'Tatton midnight',
      src: 'magnet/Price%20Configurator/colors/tatton-midnight.webp',
    },
  ],
  hoxton: [
    {
      name: 'Pebble',
      src: 'magnet/Price%20Configurator/Colors/hoxton_pebble.jpg',
    },
    {
      name: 'Metallic midnight',
      src: 'magnet/Price%20Configurator/colors/luna-matt-midnight.webp',
    },
    {
      name: 'Gloss white',
      src: 'magnet/Price%20Configurator/Colors/gloss_White.jpg',
    },
  ],
  luna: [
    {
      name: 'Luna matt midnight',
      src: 'magnet/Price%20Configurator/colors/luna-matt-midnight.webp',
    },
    {
      name: 'Luna matt graphite',
      src: 'magnet/Price%20Configurator/colors/luna-matt-graphite.webp',
    },
    {
      name: 'Luna gloss grey',
      src: 'magnet/Price%20Configurator/colors/luna-gloss-grey.webp',
    },
    {
      name: 'Luna matt white',
      src: 'magnet/Price%20Configurator/colors/luna-matt-white.webp',
    },
    {
      name: 'Luna matt grey',
      src: 'magnet/Price%20Configurator/colors/luna-matt-grey.webp',
    },
    {
      name: 'Luna cashmere',
      src: 'magnet/Price%20Configurator/colors/luna-cashmere.webp',
    },
    {
      name: 'Luna white',
      src: 'magnet/Price%20Configurator/colors/luna-white.webp',
    },
  ],
  nordicNature: [
    {
      name: 'Nordic nature',
      src: 'magnet/Price%20Configurator/Colors/nordic_oak.jpg',
    },
  ],
  fusion: [
    {
      name: 'Fusion blue',
      src: 'magnet/Price%20Configurator/colors/fusion-blue.webp',
    },
  ],
  dunham: [
    {
      name: 'Dunham morello',
      src: 'Magnet/Kitchens/Swatches/Morello_swatch.png',
    },
    {
      name: 'Dunham parchment',
      src: 'Magnet/Kitchens/Swatches/Parchment-swatch.jpg',
    },
    {
      name: 'Dunham tailored green',
      src: 'Magnet/Kitchens/Swatches/Tailored-Green_swatch.png',
    },
    {
      name: 'Dunham sumi black',
      src: 'Magnet/Kitchens/Swatches/Sumi-black-swatch.jpg',
    },
    {
      name: 'Dunham shell',
      src: 'Magnet/Kitchens/Swatches/Swatch_Shell.png',
    },
    {
      name: 'Dunham thyme',
      src: 'Magnet/Kitchens/Swatches/Swatch_Thyme.png',
    },
    {
      name: 'Dunham duck egg',
      src: 'Magnet/Kitchens/Swatches/Swatch_Duck-Egg.png',
    },
    {
      name: 'Dunham baked clay',
      src: 'Magnet/Kitchens/Swatches/Swatch_Baked-Clay.png',
    },
    {
      name: 'Dunham balmoral',
      src: 'Magnet/Kitchens/Swatches/Balmoral_swatch.png',
    },
    {
      name: 'Dunham coastland',
      src: 'Magnet/Kitchens/Swatches/Coastland_swatch.png',
    },
    {
      name: 'Dunham french clay',
      src: 'Magnet/Kitchens/Swatches/French_Clay_swatch.png',
    },
    {
      name: 'Dunham limestone',
      src: 'Magnet/Kitchens/Swatches/Limestone_swatch.png',
    },
    {
      name: 'Dunham chalk blush',
      src: 'Magnet/Kitchens/Swatches/Chalk_Blush_swatch.jpg',
    },
    {
      name: 'Dunham carrington blue',
      src: 'Magnet/Kitchens/Swatches/Carrington_blue_swatch.jpg',
    },
    {
      name: 'Dunham harvest',
      src: 'Magnet/Kitchens/Swatches/harvest_swatch.jpg',
    },
    {
      name: 'Dunham fresh linen',
      src: 'Magnet/Kitchens/Swatches/Fresh_Linen_swatch.png',
    },
    {
      name: 'Dunham midnight',
      src: 'Magnet/Kitchens/Swatches/Midnight_swatch.png',
    },
    {
      name: 'Dunham pebble path',
      src: 'Magnet/Kitchens/Swatches/Pebble_Path_swatch.png',
    },
    {
      name: 'Dunham seagrass',
      src: 'Magnet/Kitchens/Swatches/Seagrass_swatch.png',
    },
    {
      name: 'Dunham arboretum green',
      src: 'Magnet/Kitchens/Swatches/Arborteum_green_swatch.jpg',
    },
    {
      name: 'Dunham morris blue',
      src: 'Magnet/Kitchens/Swatches/Morris_Blue_swatch.png',
    },
    {
      name: 'Dunham charcoals',
      src: 'Magnet/Kitchens/Swatches/Charcoals_swatch.png',
    },
    {
      name: 'Dunham dove grey',
      src: 'Magnet/Kitchens/Swatches/Dove_Grey_swatch.png',
    },
    {
      name: 'Dunham ecalyptus green',
      src: 'Magnet/Kitchens/Swatches/Eucalyptus_swatch.png',
    },
    {
      name: 'Dunham misty moors',
      src: 'Magnet/Kitchens/Swatches/Misty_Moors_swatch.jpg',
    },
    {
      name: 'Dunham sky',
      src: 'Magnet/Kitchens/Swatches/Sky_swatch.png',
    },
    {
      name: 'Dunham washed cotton',
      src: 'Magnet/Kitchens/Swatches/Washed_Cotton_swatch.png',
    },
    {
      name: 'Dunham voyage blue',
      src: 'Magnet/Kitchens/Swatches/Voyage_blue_swatch.jpg',
    },
  ],
  ludlow: [
    {
      name: 'Ludlow morello',
      src: 'Magnet/Kitchens/Swatches/Morello_swatch.png',
    },
    {
      name: 'Ludlow parchment',
      src: 'Magnet/Kitchens/Swatches/Parchment-swatch.jpg',
    },
    {
      name: 'Ludlow tailored green',
      src: 'Magnet/Kitchens/Swatches/Tailored-Green_swatch.png',
    },
    {
      name: 'Ludlow sumi black',
      src: 'Magnet/Kitchens/Swatches/Sumi-black-swatch.jpg',
    },
    {
      name: 'Ludlow shell',
      src: 'Magnet/Kitchens/Swatches/Swatch_Shell.png',
    },
    {
      name: 'Ludlow thyme',
      src: 'Magnet/Kitchens/Swatches/Swatch_Thyme.png',
    },
    {
      name: 'Ludlow duck egg',
      src: 'Magnet/Kitchens/Swatches/Swatch_Duck-Egg.png',
    },
    {
      name: 'Ludlow baked clay',
      src: 'Magnet/Kitchens/Swatches/Swatch_Baked-Clay.png',
    },
    {
      name: 'Ludlow balmoral',
      src: 'Magnet/Kitchens/Swatches/Balmoral_swatch.png',
    },
    {
      name: 'Ludlow coastland',
      src: 'Magnet/Kitchens/Swatches/Coastland_swatch.png',
    },
    {
      name: 'Ludlow french clay',
      src: 'Magnet/Kitchens/Swatches/French_Clay_swatch.png',
    },
    {
      name: 'Ludlow limestone',
      src: 'Magnet/Kitchens/Swatches/Limestone_swatch.png',
    },
    {
      name: 'Ludlow chalk blush',
      src: 'Magnet/Kitchens/Swatches/Chalk_Blush_swatch.jpg',
    },
    {
      name: 'Ludlow carrington blue',
      src: 'Magnet/Kitchens/Swatches/Carrington_blue_swatch.jpg',
    },
    {
      name: 'Ludlow harvest',
      src: 'Magnet/Kitchens/Swatches/harvest_swatch.jpg',
    },
    {
      name: 'Ludlow fresh linen',
      src: 'Magnet/Kitchens/Swatches/Fresh_Linen_swatch.png',
    },
    {
      name: 'Ludlow midnight',
      src: 'Magnet/Kitchens/Swatches/Midnight_swatch.png',
    },
    {
      name: 'Ludlow pebble path',
      src: 'Magnet/Kitchens/Swatches/Pebble_Path_swatch.png',
    },
    {
      name: 'Ludlow seagrass',
      src: 'Magnet/Kitchens/Swatches/Seagrass_swatch.png',
    },
    {
      name: 'Ludlow arboretum green',
      src: 'Magnet/Kitchens/Swatches/Arborteum_green_swatch.jpg',
    },
    {
      name: 'Ludlow morris blue',
      src: 'Magnet/Kitchens/Swatches/Morris_Blue_swatch.png',
    },
    {
      name: 'Ludlow charcoals',
      src: 'Magnet/Kitchens/Swatches/Charcoals_swatch.png',
    },
    {
      name: 'Ludlow dove grey',
      src: 'Magnet/Kitchens/Swatches/Dove_Grey_swatch.png',
    },
    {
      name: 'Ludlow ecalyptus green',
      src: 'Magnet/Kitchens/Swatches/Eucalyptus_swatch.png',
    },
    {
      name: 'Ludlow misty moors',
      src: 'Magnet/Kitchens/Swatches/Misty_Moors_swatch.jpg',
    },
    {
      name: 'Ludlow sky',
      src: 'Magnet/Kitchens/Swatches/Sky_swatch.png',
    },
    {
      name: 'Ludlow washed cotton',
      src: 'Magnet/Kitchens/Swatches/Washed_Cotton_swatch.png',
    },
    {
      name: 'Ludlow voyage blue',
      src: 'Magnet/Kitchens/Swatches/Voyage_blue_swatch.jpg',
    },
  ],
  soho: [
    {
      name: 'Soho morello',
      src: 'Magnet/Kitchens/Swatches/Morello_swatch.png',
    },
    {
      name: 'Soho parchment',
      src: 'Magnet/Kitchens/Swatches/Parchment-swatch.jpg',
    },
    {
      name: 'Soho tailored green',
      src: 'Magnet/Kitchens/Swatches/Tailored-Green_swatch.png',
    },
    {
      name: 'Soho sumi black',
      src: 'Magnet/Kitchens/Swatches/Sumi-black-swatch.jpg',
    },
    {
      name: 'Soho shell',
      src: 'Magnet/Kitchens/Swatches/Swatch_Shell.png',
    },
    {
      name: 'Soho thyme',
      src: 'Magnet/Kitchens/Swatches/Swatch_Thyme.png',
    },
    {
      name: 'Soho duck egg',
      src: 'Magnet/Kitchens/Swatches/Swatch_Duck-Egg.png',
    },
    {
      name: 'Soho baked clay',
      src: 'Magnet/Kitchens/Swatches/Swatch_Baked-Clay.png',
    },
    {
      name: 'Soho balmoral',
      src: 'Magnet/Kitchens/Swatches/Balmoral_swatch.png',
    },
    {
      name: 'Soho coastland',
      src: 'Magnet/Kitchens/Swatches/Coastland_swatch.png',
    },
    {
      name: 'Soho french clay',
      src: 'Magnet/Kitchens/Swatches/French_Clay_swatch.png',
    },
    {
      name: 'Soho limestone',
      src: 'Magnet/Kitchens/Swatches/Limestone_swatch.png',
    },
    {
      name: 'Soho chalk blush',
      src: 'Magnet/Kitchens/Swatches/Chalk_Blush_swatch.jpg',
    },
    {
      name: 'Soho carrington blue',
      src: 'Magnet/Kitchens/Swatches/Carrington_blue_swatch.jpg',
    },
    {
      name: 'Soho harvest',
      src: 'Magnet/Kitchens/Swatches/harvest_swatch.jpg',
    },
    {
      name: 'Soho fresh linen',
      src: 'Magnet/Kitchens/Swatches/Fresh_Linen_swatch.png',
    },
    {
      name: 'Soho midnight',
      src: 'Magnet/Kitchens/Swatches/Midnight_swatch.png',
    },
    {
      name: 'Soho pebble path',
      src: 'Magnet/Kitchens/Swatches/Pebble_Path_swatch.png',
    },
    {
      name: 'Soho seagrass',
      src: 'Magnet/Kitchens/Swatches/Seagrass_swatch.png',
    },
    {
      name: 'Soho arboretum green',
      src: 'Magnet/Kitchens/Swatches/Arborteum_green_swatch.jpg',
    },
    {
      name: 'Soho morris blue',
      src: 'Magnet/Kitchens/Swatches/Morris_Blue_swatch.png',
    },
    {
      name: 'Soho charcoals',
      src: 'Magnet/Kitchens/Swatches/Charcoals_swatch.png',
    },
    {
      name: 'Soho dove grey',
      src: 'Magnet/Kitchens/Swatches/Dove_Grey_swatch.png',
    },
    {
      name: 'Soho ecalyptus green',
      src: 'Magnet/Kitchens/Swatches/Eucalyptus_swatch.png',
    },
    {
      name: 'Soho misty moors',
      src: 'Magnet/Kitchens/Swatches/Misty_Moors_swatch.jpg',
    },
    {
      name: 'Soho sky',
      src: 'Magnet/Kitchens/Swatches/Sky_swatch.png',
    },
    {
      name: 'Soho washed cotton',
      src: 'Magnet/Kitchens/Swatches/Washed_Cotton_swatch.png',
    },
    {
      name: 'Soho voyage blue',
      src: 'Magnet/Kitchens/Swatches/Voyage_blue_swatch.jpg',
    },
  ],
}

export const RANGES = {
  brunswick: 'Magnet/Kitchens/Brunswick/BRUNSWICK_SUMI_BLACK_S09.jpg',
  wardley: 'Magnet/Kitchens/Wardley/VM8026_MAGNET_MAG003_AW_PTO_SEP23_SC01_WARDLEY_BALMORAL_FRENCH_CLAY_S02_ADOBE_98.jpg',
  ascoli: 'Magnet/Kitchens/Ascoli/VM1152_MAGNET_ASCOLI_DARK_OAK_LIGHT_GREY_S03_ADOBE_98.jpg',
  nova: 'Magnet/Kitchens/Nova/Nova_Matt_Slate_Main.jpg',
  tatton: 'Magnet/Kitchens/Tatton/8864_Magnet_kitchens_photography_and_video0461.jpg',
  hoxton: 'Magnet/Kitchens/Hoxton/VM1152_MAGNET_SC02_MINIMAL_MAXIMALISM_S01_ADOBE_98.jpg',
  luna: 'Magnet/Kitchens/Luna/VM1152_MAGNET_SUMMER_22_MAR_22_SC03_S06_ADOBE_98.jpg',
  ludlow: 'Magnet/Kitchens/Ludlow/VM1044_MAGNET_SC02_LUDLOW_PEBBLE_S02_ADOBE_98.jpg',
  nordicNature: 'Magnet/Kitchens/VM1004_MAGNET_MAY_2021_SC08_NORDIC_OAK_S02_NEW_ADOBE_98_HANDLE_UPDATE.jpg',
  dunham: 'Magnet/Kitchens/Dunham/Dunham_Voyage_Larder.jpg',
  soho: 'Magnet/Kitchens/Soho/VM1152_MAGNET_SOHO_ARBORETUM_GREEN_S01_ADOBE_98.jpg',
  ambleside: 'Magnet/Kitchens/Ambleside/MAG002_AMBLESIDE_AUG23_SC03_AMBLESIDE_FERN_S03_ADOBE_98.jpg',
  bewdley: 'Magnet/Kitchens/Bewdley/Bewdley-Cornish-Clay-main.png',
  reed: 'Magnet/Kitchens/Reed/MAG01009_SUMMER_PHASE_ONE_FEB25_SC01_REED_SHELL_S06.jpg',
  portobello: 'Magnet/Kitchens/Duxbury/VM8026_MAGNET_MAG004_SC02_DUX_ARBORETUM_PORTO_UMBRA_S07_ADOBE_98.jpg',
  duxbury: 'Magnet/Kitchens/Duxbury/VM8026_MAGNET_MAG004_WINTER_SEP23_SET_01_DUXBURY_LIMESTONE_S03__ADOBE_98.jpg',  
 }

export const UNITS = {
  small: 'Magnet/Kitchens/8_unit_kitchen_image.jpg',
  medium: 'Magnet/Kitchens/12_unit_kitchen_image.jpg',
  large: 'Magnet/Kitchens/16_unit_kitchen_image.jpg',
  xlarge: 'Magnet/Kitchens/20_unit_kitchen_image.jpg',
}

export const CABINET = {
  flatPack: 'Magnet/Kitchens/Cabinets/cabinet_flat_pack.svg',
  preBuilt: 'Magnet/Kitchens/Cabinets/cabinet_pre_built.svg',
}

export const WORKTOPS = {
  timber: 'Magnet/Price%20Configurator/Worktops/timber_c_pad_b_gen_fill_w_1024_h_1024_ar_1_1.png',
  minerva: 'Magnet/Price%20Configurator/Worktops/minerva_new_c_pad_b_gen_fill_w_300_h_250.png',
  bullNosedLaminate: 'Magnet/Price%20Configurator/Worktops/Bull_nose_c_pad_b_gen_fill_w_300_h_250.png',
  squareEdgedLaminate: 'Magnet/Price%20Configurator/Worktops/square_edge_c_pad_b_gen_fill_w_1024_h_1024_ar_1_1.png',
  compact: 'Magnet/Price%20Configurator/Worktops/compact_c_pad_b_gen_fill_w_280_h_200.png',
  silestone: 'Magnet/Price%20Configurator/Worktops/silestone_c_pad_b_gen_fill_w_300_h_250.png',
  corian: 'Magnet/Price%20Configurator/Worktops/corian_c_pad_b_gen_fill_w_300_h_250.png',
  dekton: 'Magnet/Price%20Configurator/Worktops/dekton_c_pad_b_gen_fill_w_300_h_250.png',
}

export const FLOORING = {
  laminate: 'Magnet/Price%20Configurator/Flooring/Laminate.png',
  engineered: 'Magnet/Price%20Configurator/Flooring/Engineered.jpg',
  amtico: 'Magnet/Price%20Configurator/Flooring/Amtico.webp',
}

export const SINKS = {
  frankeAscona: ['Magnet/Price%20Configurator/Sinks/1.0B/Franke_Ascona.jpg','Magnet/Price%20Configurator/Sinks/1.5B/Franke_Ascona_1.5.jpg'],
  square: ['Magnet/Price%20Configurator/Sinks/1.0B/Square.jpg', 'Magnet/Price%20Configurator/Sinks/1.5B/Square_1.5.jpg'],
  composite: ['Magnet/Price%20Configurator/Sinks/1.0B/Compasite.jpg', 'Magnet/Price%20Configurator/Sinks/1.5B/Composite_1.5.jpg'],
  ceramic: ['Magnet/Price%20Configurator/Sinks/1.0B/Ceramic.jpg', 'Magnet/Price%20Configurator/Sinks/1.5B/Ceramic_1.5.jpg'],
  belfast: ['Magnet/Price%20Configurator/Sinks/1.0B/Belfast.jpg', 'Magnet/Price%20Configurator/Sinks/1.5B/Belfast_1.5.jpg'],
}

export const TAPS = {
  neptune: 'Magnet/Price%20Configurator/Taps/neptune_c_pad_ar_1_1.png',
  norrie: 'Magnet/Price%20Configurator/Taps/norrir_c_pad_ar_1_1.png',
  swan: 'Magnet/Price%20Configurator/Taps/swan_c_pad_ar_1_1.png',
  pico: 'Magnet/Price%20Configurator/Taps/pico_c_pad_ar_1_1.png',
  pronteau: 'Magnet/Price%20Configurator/Taps/abode_protrad_brass_square.png',
  agilis: 'Magnet/Price%20Configurator/Taps/agilis_c_pad_ar_1_1.png',
  hex: 'Magnet/Price%20Configurator/Taps/hex_c_pad_ar_1_1.png',
  threeInOne: 'Magnet/Price%20Configurator/Taps/quooker.png',
}

export const STORAGE = {
  traditionalLarder: 'Magnet/Price%20Configurator/Storage/traditional_larder_c_pad_b_gen_fill_w_299_h_230.jpg',
  towePullout: 'Magnet/Price%20Configurator/Storage/tower_unit.png',
  cutleryTray: 'Magnet/Price%20Configurator/Storage/cutlery_tray_c_pad_b_gen_fill_w_300_h_230.jpg',
}